import { render, staticRenderFns } from "./TileColors.vue?vue&type=template&id=4b8ac4be&scoped=true&"
import script from "./TileColors.vue?vue&type=script&lang=js&"
export * from "./TileColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8ac4be",
  null
  
)

export default component.exports